import React from "react";
import { useNavigate, useParams } from "react-router-dom"; // Added useNavigate and useParams import
import { ItemListProduct } from "../../types/post.type";
import ImageComponent from "./ImageComponent";
import i18n from "../../config/i18n"; // Import i18n

interface MovieCardProps {
  movie: ItemListProduct;
  size?: "large" | "small"; // new prop to determine card size
  onClick?: () => void; // Add onClick prop
  isSelectMode?: boolean;
  checked?: boolean;
  onSelectMovie?: (id: string) => void;
    className?: string; // Optional className for custom styling

}

const MovieCard: React.FC<MovieCardProps> = ({ movie, size = "large",className, onClick, isSelectMode = false, checked = false, onSelectMovie }) => {
  const navigate = useNavigate(); // Initialize navigate
  const { lang } = useParams<{ lang: string }>(); // Retrieve lang from URL
  
  // Updated responsive text size classes for title and like count
  const sizeTitle = size === "large" 
    ? "text-lg sm:text-xl md:text-2xl" 
    : "text-sm sm:text-[14px] md:text-[16px]";
    
  const sizeLike = size === "large" 
    ? "text-xs sm:text-sm md:text-lg" 
    : "text-[10px] sm:text-[11px] md:text-[12px]";
  
  const handleCardClick = (e?: React.MouseEvent) => {
    // Nếu đang ở chế độ select và click vào checkbox thì không chuyển trang
    if (isSelectMode) {
       onSelectMovie && onSelectMovie(String(movie.id))
      return;
    }
    if (onClick) {
      onClick();
    } else {
      const type = movie.posttype || 'movie';
      // Get current language from URL or fallback to i18n default language
      const currentLang = window.location.hash.split('/')[1] || lang || i18n.options.fallbackLng;
      const path = `/${currentLang}/${type}/${movie.slug}`;
      navigate(path, { state: { item:movie } });
      window.scrollTo(0, 0);
    }
  };
   return (
    <div 
      className={`item rounded shadow-sm w-auto h-auto cursor-pointer relative ${className}`}
      onClick={handleCardClick}
    >
      {/* Checkbox select ở góc trên bên phải */}
      {isSelectMode && (
        <div className="absolute top-2 right-2 z-10 movie-checkbox" onClick={e => e.stopPropagation()}>
          <input
            type="checkbox"
            checked={checked}
            onChange={() => onSelectMovie && onSelectMovie(String(movie.id))}
            className="w-5 h-5 accent-primary rounded border-gray-400"
          />
        </div>
      )}
      <ImageComponent
        src={movie.feature?.path}
        alt={movie.title}
        className={`rounded-t-lg object-cover w-full aspect-[9/14]`}
        width={size === "large" ? 300 : 200}
        height={size === "large" ? 420 : 280}
      />
      <div className="flex flex-col flex-grow p-1 sm:p-2">
        <h3
          className={`font-semibold leading-tight sm:leading-6 text-gray-200 mb-1 sm:mb-2 w-full break-words ${sizeTitle} line-clamp-2`}
        >
          <span className="font-bold">{movie.title}</span>
        </h3>
        <div className={`ratings mt-auto flex gap-1 sm:gap-2 font-normal text-white ${sizeLike}`}>
          <div className="like flex gap-1 items-center">
            <img 
              src="/assets/icons/like-gold.svg" 
              alt="like" 
              className="w-3 h-3 sm:w-4 sm:h-4" 
            />
            {movie.like_count || 0}
          </div>
          <div className="counter flex gap-1 items-center text-white">
            {`${movie.views || 0} ${
              movie.posttype === "game" ? "lượt chơi" : "lượt xem"
            }`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieCard;
